import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { BdpDocumentationContent } from '@shared/models/filetype/SeriesBdpRollback';
import { AppService } from '@core/services/app.service';
import { ReasonInserieActivaton } from '@core/enums/reason-inserie-activaton.enum';
import { ModalResult } from '@shared/models/ModalResult';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-fcsc-rollback-part2',
  templateUrl: './fcsc-rollback-part2.component.html',
  styleUrls: ['./fcsc-rollback-part2.component.scss'],
})
export class FcscRollbackPart2Component {
  serieBdpRollbackForm!: UntypedFormGroup;
  sortConfig = [{ prop: 'baureihe', dir: 'asc' }];
  emptyMessage!: string;

  @Input() isFromExpertTool!: string;
  @Input() seriesBdpDocumentationContent: BdpDocumentationContent[] = [];
  @Input() seriesReplacedBdpDocumentationContent: BdpDocumentationContent[] =
    [];

  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() next: EventEmitter<any> = new EventEmitter();
  @Output() submit: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(
    private appService: AppService,
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.createRollbackInSerieBdpForm();
  }

  checkVisibility(row: BdpDocumentationContent): string {
    const currentName = row?.sdpName;
    const content = this.seriesBdpDocumentationContent;
    const found = content.find((con) => con?.sdpName === currentName);
    return found ? 'option-svg-info-hidden' : 'option-svg-info';
  }

  private createRollbackInSerieBdpForm() {
      this.serieBdpRollbackForm = this.formBuilder.group({
        note: new UntypedFormControl(''),
        reason: new UntypedFormControl(
          this.appService.getValueConstant(
            ReasonInserieActivaton,
            ReasonInserieActivaton.FAULTY_BDP
          )
        ),
      });
    }

  handleBack() {
    this.back.emit();
  }

  handleNext() {
    this.next.emit();
  }
  handleSubmit(): void {
    const result = {
      ok: ModalResult.DELETE_OK || ModalResult.WARNING_OK,
      };
    this.submit.emit(this.serieBdpRollbackForm);
    this.activeModal.close(result);
  }

  handleClose() {
    this.close.emit();
  }
}
